<template>
  <div id="app">

    <ClickToEnter @clicked="clicked()">
      🔔
      click to see for whom my phone rings
      🔔
    </ClickToEnter>

    <div id="layout-wrapper">



        <NotificationToSound @notification="alert"  v-if="started" />

        <Viewer3d/>


    </div>


  </div>
</template>
<script>
import ClickToEnter from './components/ClickToEnter';
import NotificationToSound from './components/NotificationToSound';
import Viewer3d from './components/3dViewer';


export default {
  name: 'ExistenceOfAPlugApp',

  components: {
    ClickToEnter,
    NotificationToSound,
    Viewer3d
  },

  data() {
    return {
      started: false
    }
  },

  created() {

    //console.log("created");

  },

  methods: {

    clicked() {

      console.log("started????", )
      this.started = true;

    },


    alert(data) {

      //console.log("alert", data);

      this.$notify({
        group: 'foo',
        title: data.app_name,
        text: data.received_at
      });


    }

  }


}

</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Crimson+Text:ital,wght@0,400;0,600;0,700;1,400;1,600&display=swap');

body {
  background: #5079B1;
  color: white;
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  //font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  //font-family: 'Crimson Text', serif;
  //font-size: 24px;

  font-family: Times, sans-serif;
  font-size: 20vh;


}


</style>